import { useEffect, useRef } from "react";

export default function MouseTrail() {
  const canvasRef = useRef(null);
  const points = useRef([]);
  const raf = useRef(null);
  const idle = useRef(true);
  const idleTimer = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let w, h;

    const resize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener("resize", resize, { passive: true });

    const onMove = (e) => {
      idle.current = false;
      clearTimeout(idleTimer.current);
      points.current.push({ x: e.clientX, y: e.clientY, life: 1 });
      if (points.current.length > 15) points.current.shift();
      idleTimer.current = setTimeout(() => { idle.current = true; }, 2000);
    };
    window.addEventListener("mousemove", onMove, { passive: true });

    const draw = () => {
      if (idle.current && points.current.length === 0) {
        raf.current = requestAnimationFrame(draw);
        return;
      }
      ctx.clearRect(0, 0, w, h);
      for (let i = points.current.length - 1; i >= 0; i--) {
        const p = points.current[i];
        p.life -= 0.04;
        if (p.life <= 0) { points.current.splice(i, 1); continue; }
        ctx.beginPath();
        ctx.arc(p.x, p.y, 1.2 * p.life, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(244,123,32,${p.life * 0.35})`;
        ctx.fill();
      }
      raf.current = requestAnimationFrame(draw);
    };
    raf.current = requestAnimationFrame(draw);

    return () => {
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf.current);
      clearTimeout(idleTimer.current);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 z-[58] pointer-events-none hidden md:block"
      aria-hidden="true"
    />
  );
}
